/** @file The editor's settings REST client instance (browser fetch, same-origin cookies). */
import { createSettingsApi } from './createSettingsApi';

/** Used by the Settings screen; tests pass their own fake clients instead. */
export const settingsApi = createSettingsApi((url, init) => fetch(url, init));
